import script from "./Agenda.vue?vue&type=script&setup=true&lang=js"
export * from "./Agenda.vue?vue&type=script&setup=true&lang=js"

import "./Agenda.vue?vue&type=style&index=0&id=1f12525e&lang=css"

const __exports__ = script;

export default __exports__